/** Disclaimer type keys — matches Data.Core.DisclaimerTypes */
export const DISCLAIMER_TYPES = ['terms', 'privacy', 'cookie', 'warning'];
export const DISCLAIMER_TYPE_LABELS = {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    cookie: 'Cookie Policy',
    warning: 'Warning',
};
export const DISCLAIMER_LANGUAGES = [
    { value: 'en', label: 'English' },
    { value: 'tr', label: 'Türkçe' },
    { value: 'es', label: 'Español' },
    { value: 'fr', label: 'Français' },
    { value: 'de', label: 'Deutsch' },
    { value: 'ja', label: '日本語' },
];
